module.exports = __webpack_public_path__ + "img/1523780699.ab45580c.jpg";